"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFilterOptions = exports.setOrderByOptions = exports.setLimit = exports.setOffset = exports.fetchProjectUserListExcelFailure = exports.fetchProjectUserListExcelSuccess = exports.fetchProjectUserListExcelRequest = exports.fetchProjectUserListFailure = exports.fetchProjectUserListSuccess = exports.fetchProjectUserListRequest = exports.clearState = void 0;
const ActionTypes = require("../../actionTypes/project/users");
// State
const clearState = () => ({
    type: ActionTypes.CLEAR_STATE
});
exports.clearState = clearState;
const fetchProjectUserListRequest = (id) => ({
    type: ActionTypes.FETCH_PROJECT_USER_LIST_REQUEST,
    payload: {
        id
    }
});
exports.fetchProjectUserListRequest = fetchProjectUserListRequest;
const fetchProjectUserListSuccess = (users) => ({
    type: ActionTypes.FETCH_PROJECT_USER_LIST_SUCCESS,
    payload: {
        users
    }
});
exports.fetchProjectUserListSuccess = fetchProjectUserListSuccess;
function fetchProjectUserListFailure(error) {
    return {
        type: ActionTypes.FETCH_PROJECT_USER_LIST_FAILURE,
        payload: error
    };
}
exports.fetchProjectUserListFailure = fetchProjectUserListFailure;
const fetchProjectUserListExcelRequest = (id) => ({
    type: ActionTypes.FETCH_PROJECT_USER_LIST_EXCEL_REQUEST,
    payload: {
        id
    }
});
exports.fetchProjectUserListExcelRequest = fetchProjectUserListExcelRequest;
const fetchProjectUserListExcelSuccess = () => ({
    type: ActionTypes.FETCH_PROJECT_USER_LIST_EXCEL_SUCCESS
});
exports.fetchProjectUserListExcelSuccess = fetchProjectUserListExcelSuccess;
function fetchProjectUserListExcelFailure(error) {
    return {
        type: ActionTypes.FETCH_PROJECT_USER_LIST_EXCEL_FAILURE,
        payload: error
    };
}
exports.fetchProjectUserListExcelFailure = fetchProjectUserListExcelFailure;
const setOffset = (offset) => ({
    type: ActionTypes.SET_OFFSET,
    payload: {
        offset
    }
});
exports.setOffset = setOffset;
const setLimit = (limit) => ({
    type: ActionTypes.SET_LIMIT,
    payload: {
        limit
    }
});
exports.setLimit = setLimit;
const setOrderByOptions = (orderBy, order) => ({
    type: ActionTypes.SET_ORDER_BY_OPTIONS,
    payload: {
        orderBy,
        order
    }
});
exports.setOrderByOptions = setOrderByOptions;
const setFilterOptions = (filter, value) => ({
    type: ActionTypes.SET_FILTER_OPTIONS,
    payload: {
        filter,
        value
    }
});
exports.setFilterOptions = setFilterOptions;
//# sourceMappingURL=users.js.map